import { defineMessages, IntlShape } from "react-intl";

import MarkerSize from "@mapmycustomers/shared/enum/MarkerSize";

import { getDisplayName } from "./getDisplayName";

const messages = defineMessages<MarkerSize>({
  [MarkerSize.LARGE]: {
    id: "markerSize.large",
    defaultMessage: "Large",
    description: "Title of Large Marker size option",
  },
  [MarkerSize.SMALL]: {
    id: "markerSize.small",
    defaultMessage: "Small",
    description: "Title of Small Marker size option",
  },
});

const getMarkerSizeDisplayName = (intl: IntlShape, markerSize: MarkerSize) =>
  getDisplayName(intl, messages, markerSize, "MarkerSize");

export default getMarkerSizeDisplayName;
